import { getRuntimeConfig } from '../../lib/runtimeConfig';
import { buildMonolithCompaniesUrl } from '../../helpers/urls';

/* istanbul ignore next */
const publicRuntimeConfig = getRuntimeConfig() || {};

const testCompany = {
  id: 150,
  is_active: true,
  logo_url:
    'https://assets0.procore.com/assets/procore_logo_small-346b1e2f8aa349694d0aa80d078942efb968185724aa2ddc6ed6f80a0e84df90.gif',
  my_company: true,
  name: 'Big Dog Trucking',
  pcn_business_experience: true,
};

export default async function getUserCompanies() {
  if (publicRuntimeConfig.mockUserPersona && !publicRuntimeConfig.isProd) {
    return [testCompany];
  }
  const url = buildMonolithCompaniesUrl();
  if (!url) {
    return null;
  }
  const result = await fetch(url, {
    credentials: 'include',
    mode: 'cors',
  });
  if (result.ok) {
    return await result.json();
  }
  return null;
}
